export function PageContainer({ children }: { children: React.ReactNode }) {
  return (
    <main className="mx-auto max-w-7xl px-4 pt-6 pb-24 sm:px-6 lg:px-8 md:pb-6">
      {children}
    </main>
  );
}
